<template>
    <div class="editBg">
        <img src="/static/images/close.png" class="popClose" @click="hidePop">
        <div class="editTit">编辑修改区域</div>
        <div class="root">
            <div class="canvasRoot" ref="root">
                <canvas ref="canvas" @mousedown.stop="startDrawing" @mousemove="drawShape" @mouseup="endDrawing"
                    @touchstart.stop.prevent="startDrawing" @touchmove.stop.prevent="drawShape" @touchend="endDrawing"
                    v-show="showEdit"></canvas>
                <div class="tip" v-if="showTip && false">点击拖动选择修改范围</div>
            </div>
        </div>
        <div class="bot">
            <button @click="resetShape" class="resetBtn">重新选择</button>
            <button @click="exportImage" class="setBtn">确认修改</button>
        </div>
        <div class="tools">
            <div class="smallTitle" style="margin-top: 0.0404rem;">选择工具</div>
            <div class="toolsV">
                <div class="tabll">
                    <button class="bigBtn boderBtn" @click="backDraw" style="margin-right: 0.0921rem;">
                        <img class="smicon" src="/static/images/draw_back.png" />
                        撤销</button>
                    <div class="rp ">
                        <button class="rb bigBtn" @click="switchTool('fill')"
                            :class="curTool == 'fill' ? 'curToolBtn' : ''">
                            <img class="smicon" src="/static/images/draw_paint.png" />区域框选</button>
                        <button class="rb bigBtn" @click="switchTool('stroke')"
                            :class="curTool == 'stroke' ? 'curToolBtn' : ''">
                            <img class="smicon" src="/static/images/draw_block.png" />画笔涂抹</button>
                    </div>
                </div>

                <div class="smallTitle" style="margin-top: 0.1042rem;">画笔粗细设置</div>
                <div class="tabll">
                    <div>细</div> <el-slider class="sliderBar" v-model="stokeWidth" :min="1" :show-tooltip="false"
                        :max="30"></el-slider>
                    <div>粗</div>
                    <div class="widthIndex">{{ stokeWidth }}</div>
                </div>

                <div class="smallTitle" style="margin-top: 0.1042rem;">修改创意</div>
                <el-input class="input" type="textarea" :autosize="{ minRows: 3, maxRows: 4 }" @input="removeNewlines"
                    placeholder="写下你修改的创意" v-model="propMsg">
                </el-input>
            </div>

        </div>


    </div>
</template>

<script>
import { upload } from '@/utils/upload'
export default {
    data() {
        return {
            isDrawing: false,
            loadImgSuccess: false,
            canvas: null,
            context: null,
            showEdit: true,
            startCoords: { x: 0, y: 0 },
            shapeCoords: [],
            imgSrcWidth: null,
            imgSrcHeight: null,
            imgSrc: null,
            bgImg: null,
            fillShapeEnd: false,
            pathShapeList: [],
            curTool: 'stroke',
            curPath: null,
            stokeWidth: 2,
            propMsg: null

        }
    },
    mounted() {
        this.canvas = this.$refs.canvas
        this.context = this.canvas.getContext('2d')

    },
    computed: {
        showTip() {
            return !this.isDrawing && this.loadImgSuccess && !this.fillShapeEnd
        }
    },
    methods: {
        removeNewlines() {
            // 去除输入内容中的换行符
            this.propMsg = this.propMsg.replace(/[\r\n]+/g, '')
        },
        backDraw() {

            if (this.pathShapeList.length == 0) {
                return
            }

            this.loadImgSuccess = false
            this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
            this.showEdit = true
            const image = new Image()
            this.bgImg = new Image()
            this.bgImg.src = '/static/images/checkerboard.png'
            image.crossOrigin = 'anonymous'
            image.src = this.imgSrc // 替换成你的图片URL


            // this.$nextTick(() => {
            //     this.getImageSizeInfo(this.imgSrc)
            // })

            image.onload = () => {

                //  this.canvas.width = image.width
                // this.canvas.height = image.height
                // this.canvas.width = this.$refs.root.clientWidth
                // this.canvas.height = this.$refs.root.clientWidth
                // console.log(this.canvas.width + 'fff   ' + this.canvas.height)
                this.imgSrcWidth = image.width
                this.imgSrcHeight = image.height
                this.rsetCanvas()
                this.context.drawImage(image, 0, 0, image.width, image.height, 0, 0, this.canvas.width, this.canvas.height)
                this.loadImgSuccess = true
                console.log(this.pathShapeList.length)
                this.pathShapeList.splice(this.pathShapeList.length - 1, 1)
                console.log(this.pathShapeList.length)
                // 重新画图
                this.context.strokeStyle = 'green'
                this.context.fillStyle = 'green'
                // this.context.globalCompositeOperation = 'source-atop'
                for (const cp of this.pathShapeList) {
                    this.context.lineWidth = cp.stokeWidth
                    this.context.lineJoin = 'round'
                    this.context.lineCap = 'round'
                    const startXy = cp.path.shift()
                    this.context.moveTo(startXy.x, startXy.y)
                    this.context.beginPath()
                    for (const subpath of cp.path) {
                        this.context.lineTo(subpath.x, subpath.y)
                    }

                    if (cp.isFill) {
                        console.log('filllllllllll')
                        this.context.lineTo(startXy.x, startXy.y)
                        this.context.lineWidth = 10
                        this.context.fill()
                        // this.context.closePath()

                    }
                    // this.context.closePath()
                    this.context.stroke()

                }
            }

            image.onerror = () => {
                // this.$message('图片加载失败')
            }



        },

        changeImg(str) {
            this.imgSrc = str
            console.log(this.imgSrc + '   llllllllll')
            // 获取图片的真实高度
            this.pathShapeList = []
            this.loadImage()
        },
        hidePop() {
            this.isDrawing = false
            this.$emit('hidePop')
        },
        resetShape() {
            this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
            this.loadImage()
            this.pathShapeList = []

        },
        loadImage() {
            this.loadImgSuccess = false
            this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
            this.showEdit = true
            const image = new Image()
            this.bgImg = new Image()
            this.bgImg.src = '/static/images/checkerboard.png'
            image.crossOrigin = 'anonymous'
            image.src = this.imgSrc // 替换成你的图片URL


            // this.$nextTick(() => {
            //     this.getImageSizeInfo(this.imgSrc)
            // })

            image.onload = () => {
                this.imgSrcWidth = image.width
                this.imgSrcHeight = image.height
                this.rsetCanvas()
                //  this.canvas.width = image.width
                // this.canvas.height = image.height
                // this.canvas.width = this.$refs.root.clientWidth
                // this.canvas.height = this.$refs.root.clientWidth
                // console.log(this.canvas.width + 'fff   ' + this.canvas.height)
                this.context.drawImage(image, 0, 0, image.width, image.height, 0, 0, this.canvas.width, this.canvas.height)
                this.loadImgSuccess = true
                // this.$message('图片加载d')
            }

            image.onerror = () => {
                // this.$message('图片加载失败')
            }
        },
        // 获取图片真实大小 获取宽高比例 分情况 宽大于高度时    宽小于高度时

        rsetCanvas() {

            if (this.imgSrcWidth > this.imgSrcHeight) {
                const scale = (this.imgSrcHeight / this.imgSrcWidth).toFixed(2)
                console.log(scale)
                this.canvas.width = this.$refs.root.clientWidth
                this.canvas.height = this.$refs.root.clientWidth * scale
            } else if (this.imgSrcWidth < this.imgSrcHeight) {
                const scale = (this.imgSrcWidth / this.imgSrcHeight).toFixed(2)
                console.log(scale)
                this.canvas.width = this.$refs.root.clientWidth * scale
                this.canvas.height = this.$refs.root.clientWidth
            } else {
                this.canvas.width = this.$refs.root.clientWidth
                this.canvas.height = this.$refs.root.clientWidth
            }


            this.context.fillStyle = '#999999'
            this.context.fillRect(0, 0, this.canvas.width, this.canvas.height)

        },
        switchTool(str) {
            this.curTool = str

        },


        startDrawing(event) {

            if (event.offsetX == undefined) {
                console.log(this.$refs.canvas)
                const imgTop = this.$refs.canvas.getBoundingClientRect().top
                const imgLeft = this.$refs.canvas.getBoundingClientRect().left
                event.offsetX = event.changedTouches[0].pageX - imgLeft
                event.offsetY = event.changedTouches[0].pageY - imgTop




            }

            this.isDrawing = true
            const { offsetX, offsetY } = event
            this.lastX = offsetX
            this.lastY = offsetY

            console.log(event)
            const ctx = this.context
            ctx.beginPath()
            ctx.moveTo(this.lastX, this.lastY)
            this.curPath = {

            }
            this.curPath.path = []
            this.curPath.path.push({ x: this.lastX, y: this.lastY })


        },
        drawShape(event) {
            if (!this.isDrawing) return
            if (event.offsetX == undefined) {
                const imgTop = this.$refs.canvas.getBoundingClientRect().top
                const imgLeft = this.$refs.canvas.getBoundingClientRect().left
                event.offsetX = event.changedTouches[0].pageX - imgLeft
                event.offsetY = event.changedTouches[0].pageY - imgTop




            }


            const { offsetX, offsetY } = event
            const ctx = this.context
            ctx.strokeStyle = 'green' // 设置涂鸦颜色
            ctx.fillStyle = 'green'
            ctx.lineWidth = this.stokeWidth // 设置涂鸦笔触宽度
            if (this.curTool === 'fill') {
                ctx.lineWidth = 2
            }
            ctx.lineJoin = 'round'
            ctx.lineCap = 'round'

            ctx.moveTo(this.lastX, this.lastY)
            ctx.lineTo(offsetX, offsetY)
            this.curPath.stokeWidth = this.stokeWidth
            this.curPath.isFill = this.curTool === 'fill'
            this.curPath.path.push({ x: offsetX, y: offsetY })
            // this.drawPath.push({ offsetX, offsetY })

            if (this.curTool === 'fill') {
                const startXy = this.curPath.path[0]
                ctx.lineTo(startXy.x, startXy.y)
                ctx.fill()
                ctx.closePath()
            }

            ctx.stroke()
            // this.fillShape()
            this.lastX = offsetX
            this.lastY = offsetY
        },
        endDrawing() {
            this.isDrawing = false
            this.pathShapeList.push(this.curPath)

        },
        draw() {
            this.context.strokeStyle = 'red'
            this.context.lineWidth = 2

            this.context.beginPath()
            // this.context.lineTo(this.startCoords.x, this.startCoords.y)

            for (let i = 0; i < this.shapeCoords.length - 1; i++) {
                const x = (this.shapeCoords[i].x + this.shapeCoords[i + 1].x) / 2
                const y = (this.shapeCoords[i].y + this.shapeCoords[i + 1].y) / 2
                this.context.quadraticCurveTo(this.shapeCoords[i].x, this.shapeCoords[i].y, x, y)
            }

            // 连接最后一个点和第一个点形成封闭图形
            // const x = (this.shapeCoords[this.shapeCoords.length - 1].x + this.startCoords.x) / 2
            // const y = (this.shapeCoords[this.shapeCoords.length - 1].y + this.startCoords.y) / 2
            // this.context.quadraticCurveTo(this.shapeCoords[this.shapeCoords.length - 1].x, this.shapeCoords[this.shapeCoords.length - 1].y, x, y)

            // this.context.globalAlpha = 0.01
            this.context.closePath()
            // this.context.stroke()
            // this.context.save()
            // this.context.clip()
            // this.context.drawImage(this.bgImg, 0, 0, this.canvas.width, this.canvas.height)
            // this.context.restore()
            // this.context.globalAlpha = 1
        },



        exportImage() {
            // 重绘记录的图片
            if (this.pathShapeList.length == 0) {
                this.$message({ type: 'error', message: '请选择重绘区域' })
                return
            }
            if (!this.propMsg || /^[^\da-zA-Z\u4e00-\u9fa5]+$/u.test(this.propMsg)) {
                this.$message({ type: 'error', message: '请输入修改的提示词' })
                return
            }
            this.showEdit = false
            // Fill the entire canvas with black
            this.context.fillStyle = 'black'
            this.context.fillRect(0, 0, this.canvas.width, this.canvas.height)

            // Set the global composite operation to 'destination-over'
            this.context.globalCompositeOperation = 'source-atop'

            // Draw the transparent shape (inside the previously drawn shape) on the canvas
            this.context.fillStyle = 'white' // White color
            this.context.strokeStyle = 'white'
            for (const cp of this.pathShapeList) {
                this.context.lineWidth = cp.stokeWidth
                this.context.lineJoin = 'round'
                this.context.lineCap = 'round'
                const startXy = cp.path.shift()
                this.context.moveTo(startXy.x, startXy.y)
                this.context.beginPath()
                for (const subpath of cp.path) {
                    this.context.lineTo(subpath.x, subpath.y)
                }

                if (cp.isFill) {

                    this.context.lineTo(startXy.x, startXy.y)
                    this.context.lineWidth = 2
                    this.context.fill()
                    this.context.closePath()

                }
                // this.context.closePath()
                this.context.stroke()

            }
            this.pathShapeList = []


            // Reset the global composite operation to default
            this.context.globalCompositeOperation = 'source-over'

            // Export the canvas as a WebP image and trigger a download
            // 绘制小图片原图
            const image = this.canvas.toDataURL('image/webp')
            // const a = document.createElement('a')

            // a.href = image
            // a.download = 'exported_image.webp'
            // a.click()
            // 绘制大图片
            this.exportResizedImage(image)
        },
        exportResizedImage(base64Image) {
            // 创建一个新的图片对象
            this.canvasRx = document.createElement('canvas')
            this.contextRx = this.canvasRx.getContext('2d')
            const img = new Image()

            // 有先加载原图

            const rsrc = this.imgSrc.split('?')[0]
            console.log(rsrc)
            const rimage = new Image()
            rimage.onload = () => {


                img.onload = () => {

                    // 计算等比例缩放后的尺寸
                    // const scale = Math.min(rimage.width / img.width, rimage.height / img.height)

                    const newWidth = rimage.width
                    const newHeight = rimage.height
                    console.log(newHeight + '   ' + newWidth)

                    // 设置 Canvas 尺寸
                    this.canvasRx.width = newWidth
                    this.canvasRx.height = newHeight

                    // 在 Canvas 上绘制图片
                    this.contextRx.drawImage(img, 0, 0, newWidth, newHeight)

                    // Export the canvas as a WebP image and trigger a download

                    // 计算面积
                    // const imageData = this.contextRx.getImageData(0, 0, this.canvasRx.width, this.canvasRx.height)
                    //  const pixels = imageData.data
                    // let area = 0

                    // for (let i = 0; i < pixels.length; i += 4) {
                    //     const white = pixels[i] // 透明度
                    //     if (white !== 0) {
                    //         area++
                    //     }
                    // }
                    // if (area < 10000) {
                    //     this.$message('选择区域太小了,请稍微扩展选择区域')
                    //     return
                    // }

                    //             console.log('图形面积:', area)

                    const image = this.canvasRx.toDataURL('image/webp')
                    // 处理合成图片下载到本地
                    // this.$emit('exportImg', image.split(',')[1])

                    //        const a = document.createElement('a')
                    // a.href = image
                    // a.download = 'resized_image.webp'
                    // a.click()
                    const f = this.dataURItoBlob(image)
                    const file = { file: new File([f], 'aa.webp', { type: 'image/webp' }) }
                    // console.log(file)
                    upload(file).then(res => {

                        console.log(res)
                        // this.$message('上传成功' + res)
                        this.resetShape()
                        this.$emit('exportImg1', res, this.propMsg)
                        this.propMsg = null

                    })
                    //  this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)


                }
                img.src = base64Image
            }
            rimage.src = rsrc



        },
        dataURItoBlob(dataURI) {
            const byteString = atob(dataURI.split(',')[1])
            const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

            const arrayBuffer = new ArrayBuffer(byteString.length)
            const uint8Array = new Uint8Array(arrayBuffer)

            for (let i = 0; i < byteString.length; i++) {
                uint8Array[i] = byteString.charCodeAt(i)
            }

            return new Blob([arrayBuffer], { type: mimeString })
        }
    }


}
</script>

<style scoped>
canvas {
    cursor: crosshair;



}

.tools {
    right: 40px;
    position: absolute;
    top: 70px;
    font-size: 16px;
    color: #fff;
}


.toolsV {
    font-size: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
}

.toolsV button {
    background: none;
    outline: none;
    color: #fff;
    font-size: 14px;

}

button {
    border: none;
    outline: none;
    background: none;
    margin: 0;
    padding: 0;
}

.popClose {
    position: absolute;
    right: 30px;
    top: 14px;
    width: 18px;
    height: 18px;
}

.sliderBar {
    width: 70px;
    flex: 1;
    margin-left: 8px;
    margin-right: 8px;
}

.input {
    width: 100%;
    height: 150px;
    font-size: 14px;
    background: #272D40;
    border-radius: 8px;
}

.editTit {
    font-size: 20px;
    color: #fff;

    margin-top: 10px;
    margin-bottom: 26px;

}

.resetBtn {
    border-radius: 10px;
    border: 1px solid rgba(19, 203, 248, 1);
    width: 180px;
    height: 54px;
    color: #fff;
    font-size: 16px;


}

.smicon {
    width: 20px;
    height: 20px;
}


.setBtn {
    width: 180px;
    height: 54px;
    background: #06CAF9;
    border-radius: 10px;
    color: #fff;
    font-size: 16px;
}

.boderBtn {
    border: 1px solid #545C6F;
    border-radius: 8px;
}

.widthIndex {
    width: 43px;
    height: 30px;
    background: #272D40;
    border-radius: 8px;
    text-align: center;
    color: #fff;
    margin-left: 10px;
    margin-right: 10px;
    font-size: 14px;
    line-height: 30px;
}

.tabll {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #AAB2C2;
    width: 100%;

}

.tip {
    padding-left: 20px;
    padding-right: 20px;
    color: #fff;
    background: #000;
    border-radius: 20px;
    height: 40px;
    line-height: 40px;
    position: absolute;
    top: 10%;


}

.bigBtn {
    width: 68px;
    height: 68px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;


}

.curToolBtn {
    border: 1px solid #00D0FF;
}

.rp {
    display: flex;
    align-items: center;
    width: 151px;
    height: 68px;
    background: #272D40;
    border-radius: 8px;
    justify-content: space-between;
}

.smallTitle {
    color: #ABB2C1;
    font-size: 15px;
    margin-bottom: 8px;
    margin-top: 8px;
    align-self: flex-start;
    width: 100%;
    text-align: left;

}

.bot {
    margin-top: 14px;
    width: 70%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.root {
    position: relative;
    width: 700px;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.canvasRoot {
    width: 400px;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.editBg {
    padding-top: 14px;
    padding-bottom: 20px;
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/shapeDrawer/index.vue